import { getRequest, patchRequest, postRequest } from '../../../utils/requests';
import config from '../../../config.json';
import { message } from 'antd';

/**
 * Получить все настройки рассылок
 */
export const fetchNotificationSettings = async () => {
  try {
    const response = await getRequest(`${config.service}/api/notification-settings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching notification settings:', error);
    message.error('Ошибка при загрузке настроек рассылок');
    throw error;
  }
};

/**
 * Обновить статус рассылки (включить/выключить)
 */
export const updateNotificationSetting = async (type, isEnabled) => {
  try {
    const response = await patchRequest(
      `${config.service}/api/notification-settings/${type}`,
      { isEnabled }
    );
    message.success(isEnabled ? 'Рассылка включена' : 'Рассылка отключена');
    return response.data;
  } catch (error) {
    console.error('Error updating notification setting:', error);
    message.error('Ошибка при обновлении настройки');
    throw error;
  }
};

/**
 * Отправить массовое сообщение
 */
export const sendBroadcastMessage = async (messageText, recipients) => {
  try {
    const response = await postRequest(
      `${config.service}/api/notification-settings/broadcast`,
      { message: messageText, recipients }
    );
    message.success('Сообщение успешно отправлено');
    return response.data;
  } catch (error) {
    console.error('Error sending broadcast message:', error);
    message.error('Ошибка при отправке сообщения');
    throw error;
  }
};

/**
 * Инициализация настроек (seed)
 */
export const seedNotificationSettings = async () => {
  try {
    const response = await postRequest(`${config.service}/api/notification-settings/seed`);
    message.success('Настройки успешно инициализированы');
    return response.data;
  } catch (error) {
    console.error('Error seeding notification settings:', error);
    message.error('Ошибка при инициализации настроек');
    throw error;
  }
};

